var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInputBtnVisibility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#337AA6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 3.99999C10.5267 3.99999 12.78 5.41999 13.88 7.66666C12.78 9.91332 10.5267 11.3333 8.00002 11.3333C5.47335 11.3333 3.22002 9.91332 2.12002 7.66666C3.22002 5.41999 5.47335 3.99999 8.00002 3.99999ZM8.00002 2.66666C4.66669 2.66666 1.82002 4.73999 0.666687 7.66666C1.82002 10.5933 4.66669 12.6667 8.00002 12.6667C11.3334 12.6667 14.18 10.5933 15.3334 7.66666C14.18 4.73999 11.3334 2.66666 8.00002 2.66666ZM8.00002 5.99999C8.92002 5.99999 9.66669 6.74666 9.66669 7.66666C9.66669 8.58666 8.92002 9.33332 8.00002 9.33332C7.08002 9.33332 6.33335 8.58666 6.33335 7.66666C6.33335 6.74666 7.08002 5.99999 8.00002 5.99999ZM8.00002 4.66666C6.34669 4.66666 5.00002 6.01332 5.00002 7.66666C5.00002 9.31999 6.34669 10.6667 8.00002 10.6667C9.65335 10.6667 11 9.31999 11 7.66666C11 6.01332 9.65335 4.66666 8.00002 4.66666Z",
    fill: "#337AA6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputBtnVisibility);
export default __webpack_public_path__ + "static/media/input_btn-visibility.d77d47f81bc6144fbd53171279385832.svg";
export { ForwardRef as ReactComponent };